import React from 'react';
import { isNil } from 'lodash';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import Select from '../../../../../components/input/Select/Select';
import { addAllItemToSelectList, setDetailPageUrl, setNumberWithComma } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import Anchor from '../../../../../components/link/Anchor';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { POINT_LOG_TYPE_SELECT_LIST, POINT_LOG_TYPE_TEXT } from '../../../../../constants/service/app/pointConstants';
import { POINT_ISSUE_HISTORY_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';

/**
 *  포인트 내역 컬럼
 */
export const columns = (data) => {
  const { pointCauseSelectList, filterOption, onFilter } = data;

  return [
    {
      accessor: 'type',
      Header: '내역 종류',
      filterable: true,
      width: 150,
      Cell: (row) => POINT_LOG_TYPE_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={POINT_LOG_TYPE_SELECT_LIST}
          onChange={(type) => onFilter({ type })}
          defaultValue={filterOption.type}
          value={filterOption.type}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'causeName',
      Header: '적립/사용처',
      filterable: true,
      Filter: () => (
        <Select
          list={addAllItemToSelectList(pointCauseSelectList, '적립/사용처 종류 선택')}
          onChange={(pointCauseId) => onFilter({ pointCauseId })}
          defaultValue={filterOption.pointCauseId}
          value={filterOption.pointCauseId}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'amount',
      Header: '액수',
      width: 120,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'pointIssueHistoryId',
      Header: '발급 내역',
      width: 120,
      Cell: (row) =>
        !isNil(row.value) ? (
          <Anchor
            text="자세히 보기"
            color="primary"
            href={setDetailPageUrl(POINT_ISSUE_HISTORY_DETAIL_URL_PATH, row.value)}
            target="_blank"
          />
        ) : (
          '-'
        ),
    },
    {
      accessor: 'createDate',
      Header: '생성일',
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
  ];
};
